import type { AppRouter } from '@reydelgreen/server'
import { createTRPCClient, httpBatchLink } from '@trpc/client'
import { createTRPCContext } from '@trpc/tanstack-react-query'

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>()

/** Workspace ativo, enviado em todo request e lido pelo `workspaceProcedure`. */
let activeWorkspaceId: string | null = null

export function setActiveWorkspace(id: string | null) {
  activeWorkspaceId = id
}

export function createClient() {
  return createTRPCClient<AppRouter>({
    links: [
      httpBatchLink({
        url: '/api/trpc',
        // Necessário para o cookie de sessão do BetterAuth viajar.
        fetch: (input, init) => fetch(input, { ...init, credentials: 'include' }),
        headers: () => (activeWorkspaceId ? { 'x-workspace-id': activeWorkspaceId } : {}),
      }),
    ],
  })
}
